import { lazy, Suspense, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Layout } from "./Layout";
import { LoadingScreen } from "./components/LoadingScreen";
import { Dashboard } from "./pages/Dashboard";
import { CurrentUserProvider } from "./useCurrentUser";

// Hjem (Dashboard) lastes med en gang (første visning). Resten kodesplittes og
// lastes ved behov — kutter første bundle kraftig.
const ProjectsList = lazy(() => import("./pages/ProjectsList").then((m) => ({ default: m.ProjectsList })));
const ProjectDetail = lazy(() => import("./pages/ProjectDetail").then((m) => ({ default: m.ProjectDetail })));
const ProfileDemo = lazy(() => import("./pages/ProfileDemo").then((m) => ({ default: m.ProfileDemo })));
const PhaseJourney = lazy(() => import("./pages/PhaseJourney").then((m) => ({ default: m.PhaseJourney })));
const QuarterlyReport = lazy(() => import("./pages/QuarterlyReport").then((m) => ({ default: m.QuarterlyReport })));
const PortfolioDashboard = lazy(() => import("./pages/PortfolioDashboard").then((m) => ({ default: m.PortfolioDashboard })));
const SalesDashboard = lazy(() => import("./pages/SalesDashboard").then((m) => ({ default: m.SalesDashboard })));
const NyesteSalg = lazy(() => import("./pages/NyesteSalg").then((m) => ({ default: m.NyesteSalg })));
const KalkyleMotor = lazy(() => import("./pages/KalkyleMotor").then((m) => ({ default: m.KalkyleMotor })));
const Rapport = lazy(() => import("./pages/Rapport").then((m) => ({ default: m.Rapport })));
const Brukere = lazy(() => import("./pages/Brukere").then((m) => ({ default: m.Brukere })));
const MineOppgaver = lazy(() => import("./pages/MineOppgaver").then((m) => ({ default: m.MineOppgaver })));
const Innstillinger = lazy(() => import("./pages/Innstillinger").then((m) => ({ default: m.Innstillinger })));

const sideFallback = (
  <div style={{ padding: "var(--gb-space-6, 2rem)", color: "var(--gb-fg-muted, #888)" }}>
    Laster…
  </div>
);

export default function App() {
  const [laster, setLaster] = useState(true);
  return (
    <CurrentUserProvider>
      {laster && <LoadingScreen onDone={() => setLaster(false)} />}
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route
              path="/prosjekter"
              element={<Suspense fallback={sideFallback}><ProjectsList /></Suspense>}
            />
            <Route
              path="/projects/:id"
              element={<Suspense fallback={sideFallback}><ProjectDetail /></Suspense>}
            />
            <Route
              path="/profil"
              element={<Suspense fallback={sideFallback}><ProfileDemo /></Suspense>}
            />
            <Route
              path="/reise/:id/:phase"
              element={<Suspense fallback={sideFallback}><PhaseJourney /></Suspense>}
            />
            <Route
              path="/portefolje"
              element={<Suspense fallback={sideFallback}><PortfolioDashboard /></Suspense>}
            />
            <Route
              path="/salg"
              element={<Suspense fallback={sideFallback}><SalesDashboard /></Suspense>}
            />
            <Route
              path="/salg/nyeste"
              element={<Suspense fallback={sideFallback}><NyesteSalg /></Suspense>}
            />
            <Route
              path="/kalkyle"
              element={<Suspense fallback={sideFallback}><KalkyleMotor /></Suspense>}
            />
            <Route
              path="/rapporter"
              element={<Suspense fallback={sideFallback}><QuarterlyReport /></Suspense>}
            />
            <Route
              path="/oppgaver"
              element={<Suspense fallback={sideFallback}><MineOppgaver /></Suspense>}
            />
            <Route
              path="/rapport"
              element={<Suspense fallback={sideFallback}><Rapport /></Suspense>}
            />
            <Route
              path="/brukere"
              element={<Suspense fallback={sideFallback}><Brukere /></Suspense>}
            />
            <Route
              path="/innstillinger"
              element={<Suspense fallback={sideFallback}><Innstillinger /></Suspense>}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </CurrentUserProvider>
  );
}
